import { useState } from 'react';
import { Input } from 'antd';
import 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/styles/WizardTextCellEditor.less';

const WizardTextCellEditor = ({
  initialValue,
  onValueChange,
  stopEditing,
  maxLength,
  colDef,
}) => {
  const [value, setValue] = useState(String(initialValue ?? ''));

  return (
    <div className='wizard-text-cell-editor'>
      <Input
        autoFocus
        aria-label={colDef.headerComponentParams.label}
        value={value}
        maxLength={maxLength}
        showCount
        onChange={(event) => {
          setValue(event.target.value);
          onValueChange(event.target.value);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === 'Tab') {
            stopEditing();
          } else if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
            event.stopPropagation();
          }
        }}
      />
    </div>
  );
};

export default WizardTextCellEditor;
